<template>
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="level">Logros de los niños/as de 0 a 2 años</label>
        <select
          @change="handleChangeSelect"
          class="form-control"
          name="level"
          id="level"
          v-model="level"
        >
          <option v-for="item in levels" :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="area">¿Qué área quieres desarrollar?</label>
        <select
          @change="handleChangeSelect"
          class="form-control"
          name="area"
          id="area"
          v-model="area"
        >
          <option v-for="item in areas" :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-2">
      <div class="form-group">
        <label for="type">Tipo:</label>
        <select
          @change="handleChangeSelect"
          class="form-control"
          name="type"
          id="type"
          v-model="type"
        >
          <option v-for="item in types" :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-3 d-flex align-items-center justify-content-center">
      <button @click="handleChangeAnnexes" class="anexos btn mt-2 mt-lg-0">Regresar a Recursos</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      siteUrl: window.ui_school_data.site_url,
      apiPath: 'wp-json/resources/v1',
      levels: [
        { value: 'all', label: 'Mostrar todos' },
        { value: 'm03', label: '0­ a 3 meses' },
        { value: 'm36', label: '3­ a 6 meses' },
        { value: 'm69', label: '6 a  ­9 meses' },
        { value: 'm912', label: '9­ a 12  meses' },
        { value: 'a1', label: '1 año' },
        { value: 'a2', label: '2 años' },
      ],
      areas: [
        { value: 'all', label: 'Mostrar todos' },
        { value: 'emotional', label: 'Socio-emocional' },
        { value: 'adaptative', label: 'Adaptativa' },
        { value: 'cognitive', label: 'Cognitiva' },
        { value: 'language', label: 'Lenguaje' },
        { value: 'motriz', label: 'Motora ' },
      ],
      types: [],
      level: 'all',
      area: 'all',
      type: null,
    };
  },
  mounted() {
    this.getTypes();
  },
  methods: {
    getTypes() {
      this.isLoading = true;
      const apiUrl = `${this.siteUrl}/${this.apiPath}/types`;
      axios
        .post(apiUrl, {
          source: 'anexos',
        })
        .then((response) => {
          if (response.status === 200) {
            this.types = response.data;
            this.type = response.data[0].value;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log('error :', error);
          this.isLoading = false;
        });
    },
    handleChangeSelect() {
      this.$emit('change', {
        level: this.level,
        area: this.area,
        type: this.type,
        source: 'anexos',
      });
    },
    handleChangeAnnexes() {
      this.$emit('filtersAnnexes', {});
    },
  },
};
</script>

<style scoped>
.anexos {
  background-color: #eafaf6;
  font-size: 14px;
  padding: 15px;
}
.col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-auto {
  position: relative !important;
  width: 100% !important;
  min-height: 1px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
</style>
